import { getDocument } from '@atlaskit/browser-apis';
import type { EditorView } from '@atlaskit/editor-prosemirror/view';

/**
 * Restores keyboard focus to the editor once it's editable again after an AI stream
 * disabled it, so undo/redo can reach it. Ignores focus still in the closing AI prompt
 * modal, but respects focus that's moved anywhere else (e.g. a search field).
 *
 * Checks `view.editable` since other sources (e.g. Confluence's AIFC bridge) can
 * independently keep the editor disabled.
 */
export function reclaimEditorFocus(view: EditorView | undefined): void {
	if (!view || view.isDestroyed || typeof view.focus !== 'function') {
		return;
	}
	if (!view.editable) {
		return;
	}
	if (typeof view.hasFocus === 'function' && view.hasFocus()) {
		return;
	}

	const doc = getDocument();
	const activeElement = doc?.activeElement;
	if (activeElement && activeElement !== doc?.body) {
		const editorContentArea = view.dom?.closest<HTMLElement>('.ak-editor-content-area');
		const aiModalRegion = doc?.querySelector<HTMLElement>('.ak-editor-plugin-ai-modal');
		const isInsideEditorOrClosingAiModal =
			editorContentArea?.contains(activeElement) || aiModalRegion?.contains(activeElement);
		if (!isInsideEditorOrClosingAiModal) {
			return;
		}
	}

	view.focus();
}
